import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const usePasswordRecovery = () => {
  const { isRecoveryMode, setIsRecoveryMode } = useAuth();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        console.log('PASSWORD_RECOVERY event received');
        setIsRecoveryMode(true);
        // Clean URL
        window.history.replaceState(null, '', window.location.pathname);
        // Session stays valid so updateUser() will work
      }
    });

    return () => subscription.unsubscribe();
  }, [setIsRecoveryMode]);

  const clearRecoveryMode = () => {
    setIsRecoveryMode(false);
  };

  return { isRecoveryMode, clearRecoveryMode };
};
